const homePage = 'http://indifrog.com'

export { homePage }

export default {
  homePage
}
